<template>
    <div class="px-4 py-8 sm:px-6 md:py-12 lg:px-16 bg-[#00395A0D]">
        <h2 class="text-3xl sm:text-[40px] font-[900] mb-6 capitalize text-left">Our Services</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            <a v-for="(item, index) in serviceItems"
               :key="index"
               :href="item.linkUrl"
               class="block bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ease-in-out group flex flex-col items-center text-center">
                
                <img :src="item.linkMedia" alt="Service Image" class="w-full h-32 object-cover mb-4">
                
                <h3 class="text-lg font-semibold text-[#00395a] group-hover:underline leading-tight">
                    {{ item.linkName }}
                </h3>
            </a>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomeServices',
  props: {
    serviceItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // Additional data properties can be added here if needed
    };
  },
  methods: {
    // Methods can be added here if needed
  }
 
};
</script>